module.exports = __webpack_public_path__ + "img/r2.c0410f36.png";